import { render, staticRenderFns } from "./PhotoInfo.vue?vue&type=template&id=5f1b6b6f"
import script from "./PhotoInfo.vue?vue&type=script&lang=js"
export * from "./PhotoInfo.vue?vue&type=script&lang=js"
import style0 from "./PhotoInfo.vue?vue&type=style&index=0&id=5f1b6b6f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports